// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2b9c8718","453":"82d2d03b","455":"739fca04"}[chunkId] + ".chunk.js";
};